import Button from "@/shared/form/button";
import { FormInModal } from "@/shared/form/form-in-modal";
import { SaveDynamicProcessModelForm } from "../../features/save-entity-based-dynamic-process-model";
import { useTranslations } from "use-intl";

export function EditDynamicProcess({
  processId,
  name,
}: {
  processId: string;
  name: string;
}) {
  const t = useTranslations("EditDynamicProcess");

  return (
    <FormInModal
      modalProps={{
        width: "80vw",
      }}
      title={t("Edit process")}
      form={(close) => (
        <SaveDynamicProcessModelForm
          afterSubmit={close}
          processId={processId}
        />
      )}
      trigger={(open) => (
        <Button type="link" className="!text-left" onClick={open}>
          {name}
        </Button>
      )}
    />
  );
}
